import { DocumentTextIcon } from '@heroicons/react/24/outline'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import DOMPurify from 'dompurify'

function ArticleCard({ article, projectUuid, ...rest }) {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString()
    }

    // Function to detect if content is HTML (same as ArticleDetail.js)
    const isHTML = (str) => {
        if (!str) return false
        return /<(p|div|h[1-6]|br|ul|ol|li|strong|em|b|i|span)[\s>]/i.test(str) || /<\/[a-z]+>/i.test(str)
    }

    return (
        <div {...rest}>
            <div className='flex flex-col shadow-2xl px-4 py-4 w-full bg-white rounded-2xl h-full '>
                <div className='flex justify-between flex-col sm:flex-row'>
                    <div className='flex items-center justify-start mb-4 ml-1'>
                        <DocumentTextIcon className='w-9 h-9' />
                        <div className=' pl-4'>
                            <div className='text-base font-semibold  text-gray-900'>
                                {article.article_title}
                            </div>
                            <div className='text-xs text-gray-500 mt-1'>
                                {t('articles.created')}: {formatDate(article.created_at)}
                            </div>
                        </div>
                    </div>
                    <div className='flex h-fit gap-2'>
                        <button className='border border-black bg-black text-white rounded-lg px-4 py-1.5 text-sm mb-2 w-full'
                            onClick={() => { navigate(`/project/${projectUuid}/article/${article.id}`) }}
                        >{t('articles.open')}</button>
                    </div>
                </div>
                <div className='px-2 py-4 border-t-2 border-dotted h-full'>
                    <div className='text-gray-700 mb-2'>
                        <div className="prose prose-sm max-w-none">
                            {isHTML(article.article_details) ? (
                                <div 
                                    dangerouslySetInnerHTML={{ 
                                        __html: DOMPurify.sanitize(article.article_details?.replace(/\n/g, '<br>') || '')
                                    }}
                                    style={{ 
                                        lineHeight: '1.6',
                                        textAlign: 'justify'
                                    }}
                                />
                            ) : (
                                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                    {article.article_details || ''}
                                </ReactMarkdown>
                            )}
                        </div>
                    </div>
                    <div className='flex gap-4 text-xs text-gray-500'>
                        <span>{article.article_pages} {t('articles.pages')}</span>
                        <span>{article.sections ? article.sections.length : 0} {t('articles.sections')}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ArticleCard